const state = {};

const mutations = {
  setCity(state, address) {
    window.sessionStorage.setItem('address', JSON.stringify(address));
    Object.assign(state, address);
  }
};

const actions = {
  setCity({ commit }, address) {
    commit('setCity', address);
  }
};

export default {
  state,
  mutations,
  actions
};
